import React, { useEffect, useRef, useState } from 'react';
import Head from 'next/head';
import { Block, Spacer, Text, useTheme, View } from 'vcc-ui';
import { PageLayout } from './page';

const headers = ['h1', 'h2', 'h3', 'h4'];
const TOCLink = ({ type, text, href }) => {
  const theme = useTheme();
  const ref = useRef();
  const [color, setColor] = useState(theme.color.foreground.primary);
  useEffect(() => {
    const handler = () => {
      if (window.location.hash === href) {
        setColor(theme.color.ornament.highlight);
        ref?.current?.scrollIntoView?.();
      } else {
        setColor('');
      }
    };
    handler();
    window.addEventListener('hashchange', handler);
    return () => {
      window.removeEventListener('hashchange', handler);
    };
  }, [theme, href]);
  return (
    <View>
      <Text
        ref={ref}
        subStyle="inline-link"
        extend={() => ({
          paddingLeft: (Number(type?.replace('h', '')) - 1) * 12,
          textDecoration: 'none',
          ...(color && {
            color: `${color} !important`,
          }),
        })}
        href={href}
      >
        {text}
      </Text>
      <Spacer />
    </View>
  );
};

export default function Layout({
  children,
  currentTheme,
  setCurrentTheme,
  pageTitle,
}) {
  const title = pageTitle || children[0].props.children;

  const tableOfContents = (
    <Block
      extend={{
        '@media (max-width: 1279px)': {
          display: 'none',
        },
      }}
    >
      <Block
        as="ul"
        extend={{
          position: 'sticky',
          padding: 0,
          overflowY: 'scroll',
          scrollBehavior: 'smooth',
          '::-webkit-scrollbar': {
            display: 'none',
          },
          top: 140,
        }}
      >
        {React.Children.map(children, (child) => {
          const type = child?.props?.mdxType;
          if (headers.includes(type)) {
            const href = `#${child?.props?.id}`;
            return (
              <Block as="li" extend={{ margin: 0 }}>
                <TOCLink
                  type={type}
                  href={href}
                  text={child?.props?.children}
                />
              </Block>
            );
          }
          return null;
        })}
      </Block>
    </Block>
  );

  return (
    <>
      <Head>
        <title>{title} - Web UI Documentation</title>
      </Head>
      <PageLayout
        setCurrentTheme={setCurrentTheme}
        currentTheme={currentTheme}
        extra={tableOfContents}
      >
        {children}
        {tableOfContents}
      </PageLayout>
    </>
  );
}
